import { jsxs as o, jsx as i } from "react/jsx-runtime";
import t from "styled-components";
import n from "../../Icons/Viclogo.js";
import r from "../../../utils/colors.js";
import { device as e } from "../../../utils/device.js";
const a = t.div`
  display: flex;
  flex-direction: row;
  color: ${r.white};
  padding: 60px 20px 40px;
  align-items: baseline;

  @media ${e.isTablet} {
    width: 95vw;
    padding: 3rem 0;
    justify-content: flex-end;
    align-items: center;
  }

  @media ${e.isDesktop} {
    width: 960px;
    margin: auto;
    padding: 3rem;
    align-items: center;
    justify-content: flex-end;
  }
`, l = t.div`
  color: ${r.white};
  font-size: 14px;
  transform: translateY(-4px);

  @media ${e.isTablet} {
    padding-right: 40px;
    font-size: inherit;
  }

  @media ${e.isDesktop} {
    padding-right: 60px;
  }
`, s = t.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 61.22px;
  transform: translateY(-3px);

  @media ${e.isTablet} {
    height: 61.015px;
  }

  @media ${e.isMobile} {
    transform: translateY(-13px);
    align-self: flex-start;
  }
`, d = t.a`
  width: 100%;
  height: 100%;
`, h = () => /* @__PURE__ */ o(a, { children: [
  /* @__PURE__ */ o(l, { children: [
    "© State Government of Victoria ",
    (/* @__PURE__ */ new Date()).getFullYear()
  ] }),
  /* @__PURE__ */ i(s, { children: /* @__PURE__ */ i(
    d,
    {
      href: "https://www.vic.gov.au",
      "aria-label": "Go to State Government of Victoria website",
      children: /* @__PURE__ */ i(n, { fill: "white" })
    }
  ) })
] });
export {
  h as default
};
